import { render, staticRenderFns } from "./ProductsBlock.vue?vue&type=template&id=8fcf61e4&"
import script from "./ProductsBlock.js?vue&type=script&lang=js&"
export * from "./ProductsBlock.js?vue&type=script&lang=js&"
import style0 from "./ProductsBlock.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports